<template>
  <div class="LeftDate-RightTitle">
    <div class="content">
      <div :class="['left-content', list.length == 4 && 'narrow', list.length < 4 && 'less']">
        <div
          v-for="(item,index) in cp_leftList"
          :key="index"
          class="item"
          @click="onClickItem(item)"
        >
          <div class="left-date">
            <div class="day">
              {{ item.day }}
            </div>
            <div class="date">
              {{ item.formatDate }}
            </div>
          </div>
          <div class="right-title">
            {{ item.title }}
          </div>
        </div>
      </div>
      <div
        v-if="cp_rightList.length"
        class="right-content"
      >
        <div
          v-for="(item,index) in cp_rightList"
          :key="index"
          class="right-item"
          @click="onClickItem(item)"
        >
          <div>●</div>
          <div class="right-item-title">
            {{ item.title }}
          </div>
          <div>{{ item.formatDate }}</div>
        </div>
      </div>
    </div>
    <seeMore
      v-if="list.length > 10"
      @click="goMore"
    />
  </div>
</template>

<script>
import seeMore from '../seeMore';
import { findRootNode, openUrl } from '../../../../../../lib/utils';
export default {
    name: 'LeftDateRightTitle',
    components: {
        seeMore,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        rootId: {
            type: [String, Number],
            default: '',
        },
        list: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        cp_list () {
            let result = this.list;
            if (this.list.length > 10) {
                result = this.list.slice(0, 10);
            }
            return result.map((itm, idx) => {
                const date = new Date(itm.createTime);
                const year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                month = month < 10 ? '0' + month : month;
                day = day < 10 ? '0' + day : day;
                return Object.assign(itm, { day, formatDate: idx < 4 ? `${year}-${month}` : `${year}-${month}-${day}` });
            });
        },
        cp_leftList () {
            return this.cp_list.slice(0, Math.min(4, this.cp_list.length));
        },
        cp_rightList () {
            if (this.cp_list.length > 4) {
                return this.cp_list.slice(4, this.cp_list.length);
            }
            return [];
        },
        flatTreeList () {
            return this.$store.getters['system/getFlatTreeList'];
        },
        rootNode () {
            return findRootNode(this.flatTreeList, this.rootId);
        },
        catalogId () {
            const node = this.flatTreeList.find(itm => +itm.pCatalogId === this.rootNode.catalogId);
            if (node) return node.catalogId;
            return this.rootNode.catalogId;
        },
    },
    methods: {
        onClickItem (item) {
            const query = this.$route.query;
            const routeUrl = this.$router.resolve({
                path: '/webModulePage/articleDetail',
                query: {
                    catalogId: this.catalogId,
                    currCatalogId: item.catalogId,
                    contentId: item.contentId,
                    siteId: query.siteId,
                    preview: query.preview,
                    from: 'home',
                },
            });
            openUrl(routeUrl.href);
        },
        goMore () {
            const query = this.$route.query;
            const routeUrl = this.$router.resolve({
                path: '/webModulePage/articleList',
                query: {
                    catalogId: this.catalogId,
                    siteId: query.siteId,
                    preview: query.preview,
                    from: 'home',
                },
            });
            openUrl(routeUrl.href);
        },
    },
};
</script>

<style scoped lang="scss">
@import "../../style.scss";
.LeftDate-RightTitle {
    width: $pageWidth;
    box-sizing: border-box;
    margin: 0px auto;
    .content {
        display: flex;
        flex-wrap: nowrap;
        flex-direction: row;
        margin-top: 40px;
        width: 100%;
        .left-content {
            display: flex;
            flex-wrap: wrap;
            box-sizing: border-box;
            max-width: 614px;
            &.less {
                max-width: unset;
                .item {
                    margin-right: 20px;
                }
            }
            .item {
                width: 296px;
                height: 160px;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                transition: box-shadow .3s;
                cursor: pointer;
                color: #657180;
                padding: 20px;
                margin-bottom: 20px;
                box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
                &:nth-child(odd){
                    margin-right: 20px;
                }
                &:hover {
                    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.2);
                    .left-date .date {
                        &::after {
                            width: 51px;
                        }
                    }
                    .right-title {
                        color: #2873E9;
                    }
                }
                .left-date {
                    width: 76px;
                    .day {
                        font-size: 32px;
                        color: #464C5B;
                    }
                    .date {
                        font-size: 14px;
                        transition: width .3s;
                        display: inline-flex;
                        flex-direction: column;
                        width: 70px;
                        &:after{
                            content: '';
                            display: block;
                            width: 30px;
                            height: 2px;
                            max-width: 100%;
                            margin-top: 2px;
                            background: #2873E9;
                            border-radius: 4px;
                            transition: width .3s;
                        }
                    }
                }
                .right-title {
                    flex: auto;
                    font-size: 14px;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    line-height: 24px;
                    overflow: hidden;
                    -webkit-line-clamp: 4;
                    /*! autoprefixer: off */
                    -webkit-box-orient: vertical;
                    /* autoprefixer: on */
                    text-align: justify;
                    word-break: break-all;
                }
            }
            &.narrow {
                flex-wrap: nowrap;
                justify-content: space-between;
                width: 100%;
                max-width: unset;
                .item {
                    width: 290px;
                    margin-right: 0;
                    margin-bottom: 0;
                    &:nth-child(odd){
                        margin-right: 0px;
                    }
                }
            }
        }
        .right-content {
            width: 575px;
            height: 342px;
            background-color: #F9F9F9;
            box-sizing: border-box;
            margin-left: 20px;
            .right-item {
                width: 575px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                cursor: pointer;
                box-sizing: border-box;
                padding: 20px;
                padding-bottom: 15px;
                font-size: 16px;
                word-break: keep-all;
                color: #657180;
                transition: color .3s;
                &:hover {
                    color: #2873E9;
                }
                .right-item-title {
                    width: 410px;
                    margin-right: 5px;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                }
            }
        }
    }
}
</style>
